import { render, staticRenderFns } from "./EditPostscript.vue?vue&type=template&id=685eff68"
import script from "./EditPostscript.vue?vue&type=script&lang=ts"
export * from "./EditPostscript.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports